import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Inplace } from 'primeng/inplace';
import { HelpersService } from '../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../services/rentals.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-rental-accessories',
  templateUrl: './rental-accessories.component.html',
  styleUrls: ['./rental-accessories.component.scss'],
  providers: [MessageService],
})
export class RentalAccessoriesComponent implements OnInit {
  public loading: boolean = false;
  public rentalAccessories: any = [];
  public filteredRentalAccessories: any = [];
  public categories: any = [];
  public brands: any = [];
  public expandedAccessory: any = {};
  public selectedCategoryFilter: any = {};
  public selectedBrandFilter: any = {};
  public isCloneAccessory: boolean = false;
  public showRentalAccessory: boolean = false;
  public selectedAccessory: any = {};

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    public messageService: MessageService,
  ) {}

  ngOnInit() {
    this.getRentalAccessories();
  }

  getRentalAccessories() {
    this.loading = true;
    this.rentalsService
      .getRentalAccessories(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.rentalAccessories = res;
          this.loading = false;
          this.rentalAccessories.forEach((x) => {
            x.sizes = x.rentalAccessories
              .map((y) => {
                return y.size ? y.size.toUpperCase() : '';
              })
              .filter(
                (v, i, a) =>
                  a
                    .map((y) => {
                      return y;
                    })
                    .indexOf(v) === i,
              );
          });
          this.filterRentalAccessories();
          this.setFilters();
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  setFilters() {
    if (this.selectedCategoryFilter.accessoryCategoryID) {
      this.brands = this.filteredRentalAccessories
        .map((x) => {
          return { brand: x.brand };
        })
        .filter(
          (v, i, a) =>
            a
              .map((x) => {
                return x.brand;
              })
              .indexOf(v.brand) === i,
        );
    } else if (this.selectedBrandFilter.brand) {
      this.categories = this.filteredRentalAccessories
        .map((x) => {
          return {
            accessoryCategoryID: x.accessoryCategoryID,
            categoryName: x.categoryName,
          };
        })
        .filter(
          (v, i, a) =>
            a
              .map((x) => {
                return x.accessoryCategoryID;
              })
              .indexOf(v.accessoryCategoryID) === i,
        );
    } else {
      this.brands = this.filteredRentalAccessories
        .map((x) => {
          return { brand: x.brand };
        })
        .filter(
          (v, i, a) =>
            a
              .map((x) => {
                return x.brand;
              })
              .indexOf(v.brand) === i,
        );
      this.categories = this.filteredRentalAccessories
        .map((x) => {
          return {
            accessoryCategoryID: x.accessoryCategoryID,
            categoryName: x.categoryName,
          };
        })
        .filter(
          (v, i, a) =>
            a
              .map((x) => {
                return x.accessoryCategoryID;
              })
              .indexOf(v.accessoryCategoryID) === i,
        );
    }
  }

  setSearch(value) {
    console.log(value);
    this.filteredRentalAccessories = this.rentalAccessories.filter((x) => {
      return (
        x.brand.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        x.name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        x.categoryName.toLowerCase().indexOf(value.toLowerCase()) > -1
      );
    });
    this.setFilters();
  }

  filterRentalAccessories() {
    this.filteredRentalAccessories = this.rentalAccessories;
    if (this.selectedCategoryFilter.accessoryCategoryID) {
      this.filteredRentalAccessories = this.filteredRentalAccessories.filter(
        (x) => {
          return (
            x.accessoryCategoryID ===
            this.selectedCategoryFilter.accessoryCategoryID
          );
        },
      );
    }
    if (this.selectedBrandFilter.brand) {
      this.filteredRentalAccessories = this.filteredRentalAccessories.filter(
        (x) => {
          return x.brand === this.selectedBrandFilter.brand;
        },
      );
    }
  }

  selectCategoryFilter(value) {
    if (
      value.accessoryCategoryID ===
      this.selectedCategoryFilter.accessoryCategoryID
    ) {
      this.selectedCategoryFilter = {};
    } else {
      this.selectedCategoryFilter = value;
    }
    this.filterRentalAccessories();
    this.setFilters();
  }

  selectBrandFilter(value) {
    if (value.brand === this.selectedBrandFilter.brand) {
      this.selectedBrandFilter = {};
    } else {
      this.selectedBrandFilter = value;
    }
    this.filterRentalAccessories();
    this.setFilters();
  }

  expandAccessory(accessory) {
    console.log(accessory);
    if (
      accessory.brand == this.expandedAccessory.brand &&
      accessory.name == this.expandedAccessory.name &&
      accessory.accessoryCategoryID ==
        this.expandedAccessory.accessoryCategoryID
    ) {
      this.expandedAccessory = {};
    } else {
      this.expandedAccessory = accessory;
    }
  }

  editAccessory(Accessory) {
    this.selectedAccessory = Accessory;
    this.isCloneAccessory = false;
    this.showRentalAccessory = true;
  }

  cloneAccessory(Accessory) {
    this.selectedAccessory = Accessory;
    this.isCloneAccessory = true;
    this.showRentalAccessory = true;
  }

  hashCode(str) {
    var hash = 0;
    if (str) {
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
    }
    return hash;
  }

  intToRGB(i) {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();
    return '00000'.substring(0, 6 - c.length) + c;
  }

  closeRentalAccessory() {
    this.showRentalAccessory = false;
  }

  addNewRentalAccessory() {
    this.selectedAccessory = {};
    this.isCloneAccessory = false;
    this.showRentalAccessory = true;
  }

  updateRecord(accessory, object: Inplace) {
    this.rentalsService
      .updateRentalAccessoryInline(
        this.helpersService.getPartnerId(),
        accessory,
      )
      .subscribe(
        (res) => {
          object.deactivate(null);
        },
        (err) => {},
      );
  }

  isAccessoryComplete(accessory) {
    if (
      accessory.rentalAccessories.filter((x: any) => {
        return (
          x.priceGroupID === null ||
          x.priceGroupID === undefined ||
          x.priceGroupID === 0
        );
      }).length > 0
    ) {
      return false;
    } else {
      return true;
    }
  }
}
